//router
import Router from './router';
//util
import ScrollToTop from './utils/ScrollToTop';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './hooks/auth';

function App() {
  const theme = createTheme();
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <ScrollToTop />
        <Router />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
